import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Skeleton } from '@mui/material';
import api from 'api/api';

const PromptActionsModal = ({ prompt, onClose,setSeverity,setAlertMessage,  ismodal, setOpen,selectedTemplate, setLoadings }) => {
  const [currentPrompt, setCurrentPrompt] = useState(prompt);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [newPrompt, setNewPrompt] = useState('');
  const [previousPrompt, setPreviousPrompt] = useState('');

  const fetchUser = async () => {
    try {
      const userResponse = await api.get('/auth/me');
      setUser(userResponse);
      const matchedTemplate = userResponse?.templates?.templates?.find((t) => t.template === selectedTemplate);
      setPreviousPrompt(matchedTemplate?.post_processing_prompt || '');
    } catch (error) {
      console.error('Failed to fetch user data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (ismodal) {
      fetchUser();
    }
  }, [ismodal]);

  if (!ismodal) return null;

  const handleNewPromptChange = (e) => {
    setNewPrompt(e.target.value);
  };

  const handleUpdate = async(x) => {
   try {
      setLoadings(true)
      const response =await api.put(`/v1/user/set-template-prompt`,{
         "tempalte_name": selectedTemplate,
    "prompt": x
      })
      if(response.status===200){
        setSeverity('success')
        setNewPrompt('')
        setPreviousPrompt('')
        setAlertMessage(x?response?.message:"Prompt Deleted Successfully")
        setOpen(true)
        onClose(false)
      }else{
        setSeverity('info')
        setAlertMessage(response?.message)
        setOpen(true)

      }
    } catch (error) {
      console.log(error)
    }finally{
  setLoadings(false)
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-lg w-full max-w-lg relative shadow-lg">
        {/* Close Icon */}
        <FontAwesomeIcon
          icon={faTimes}

          className="absolute top-4 right-4 text-gray-600 cursor-pointer"
          onClick={() => {
            setNewPrompt('')
            setPreviousPrompt('')
            onClose(false)}}
        />

        {loading ? (
          <Skeleton variant="rectangular" width="100%" height={80} />
        ) : (
          <>
            {/* Previous Prompt Section - Only Display if previousPrompt Exists */}
            {previousPrompt && (
        <div className="p-6 w-full bg-white shadow-lg rounded-lg border border-gray-200 mb-6 mt-4">
        <div className="flex justify-between items-center">
          <h3 className="text-md font-bold text-gray-700">Active Prompt:</h3>
          <FontAwesomeIcon
            onClick={() => handleUpdate('')}
            icon={faTrash}
            className="text-red-500 cursor-pointer hover:text-red-700 transition-colors duration-300"
          />
        </div>
        {/* Scrollable Paragraph */}
        <div className="mt-4 max-h-36 overflow-y-auto">
          <p className="text-start break-words text-gray-600">{previousPrompt}</p>
        </div>
      </div>
      
            )}

            {/* Add New Prompt Section */}
            <h3 className="text-md font-bold text-gray-700 mb-2 text-start">Add New Prompt:</h3>
            <textarea
              className="w-full h-32 p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Type your new prompt here..."
              value={newPrompt}
              onChange={handleNewPromptChange}
            />

            {/* Update Button */}
            <div className="flex justify-center mt-6">
              <button
                onClick={()=>handleUpdate(newPrompt)}
                className="bg-[#1C2A3A] text-white font-semibold py-2 px-8 rounded-lg hover:bg-opacity-90 transition-all duration-300"
              >
                Update
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PromptActionsModal;
